import React, { FC, useMemo } from 'react';
import moment from 'moment-timezone';

import { IDepartmentAbsenceDTO } from 'src/api/dtos';
import { Modal, Status } from 'src/shared/components';
import { DAY_COMMA_DATE_FORMAT } from 'src/shared/constants';
import { useTranslate } from 'src/shared/providers';
import { formatEmployeeName } from 'src/shared/utils';

import { CalendarEmployeeInfo, CalendarTimeInfo } from './modal-content';

interface Props {
  item: IDepartmentAbsenceDTO;
  open: boolean;
  onClose: () => void;
}

export const CalendarDepartmentAbsenceModal: FC<Props> = ({ item, open, onClose }) => {
  const { t } = useTranslate();
  const { startDate, endDate, endTime, startTime, timeCategoryName, employee } = item;
  const formattedStartDate = moment(startDate).format(DAY_COMMA_DATE_FORMAT);
  const formattedEndDate = moment(endDate).format(DAY_COMMA_DATE_FORMAT);

  const employeeName = useMemo(() => {
    return formatEmployeeName(employee);
  }, [employee]);

  return (
    <Modal
      type="success"
      open={open}
      onClose={onClose}
      modalHeaderProps={{
        title: `${timeCategoryName} - ${t('absences.scheduledAbsence')}`,
        message:
          formattedStartDate === formattedEndDate ? formattedStartDate : `${formattedStartDate} - ${formattedEndDate}`,
        startIcon: <Status size="large" variant="success" />,
        onClose,
      }}
    >
      <div className="ms-3 ps-3">
        {startTime && endTime && <CalendarTimeInfo startTime={startTime} endTime={endTime} />}
        <CalendarEmployeeInfo name={employeeName} />
      </div>
    </Modal>
  );
};
